import { Drawer, Group, Stack, Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { IconPlus } from "@tabler/icons-react"
import { Button, DataFetchWrapper, Loader, Select } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { useActivitiesContext } from "~/components/contexts/useActivitiesContext"
import { ProductionSiteFieldDefinitionCreationForm } from "~/pages/Admin/MasterLists/ProductionSiteFieldDefinitions/ProductionSiteFieldDefinitionCreationForm"
import { useListProdSiteFieldDefsQuery } from "~/pages/Admin/MasterLists/ProductionSiteFieldDefinitions/hooks/useListProdSiteFieldDefsQuery"
import { useAuth } from "~/store/auth-context"

import { useListOrganizationsQuery } from "../../Organizations/hooks"

import { ProductionSiteFieldDefititionsTable } from "./ProductionSiteFieldDefititionsTable"

export const ProdSiteFieldDefsAdminWrapper = () => {
  const { user } = useAuth()
  const { t } = useTranslation("admin")
  const [organizationId, setOrganizationId] = useState<number>(
    user?.organization?.id ?? 1
  )
  const prodSiteFieldDefsQuery = useListProdSiteFieldDefsQuery(organizationId)
  const activities = useActivitiesContext()

  const { data: organizations, isLoading } = useListOrganizationsQuery()
  const selectOptions = organizations
    ? organizations.map((organization) => ({
        label: organization.name,
        value: organization.id.toString(),
      }))
    : []

  const [openedCreate, { open: openCreate, close: closeCreate }] =
    useDisclosure(false)

  return (
    <Stack>
      {isLoading ? (
        <Loader fullPage />
      ) : (
        <Group justify="space-between">
          <Select
            data={selectOptions}
            value={organizationId.toString()}
            w={300}
            styles={{
              input: {
                backgroundColor: "white",
              },
            }}
            onChange={(value) => setOrganizationId(value ? +value : 0)}
          />
          <Group>
            <Button
              onClick={() => {
                openCreate()
              }}
              icon={<IconPlus />}
            >
              {`New Production Site Field for ${
                organizations?.find((o) => o.id === organizationId)?.name
              }`}
            </Button>
          </Group>
        </Group>
      )}
      <Drawer
        position="right"
        opened={openedCreate}
        onClose={closeCreate}
        size="lg"
        title={<Text size="lg">{t("prodSiteFieldDefs.create")}</Text>}
      >
        <ProductionSiteFieldDefinitionCreationForm
          organizationId={organizationId}
          close={closeCreate}
          activityNames={activities?.map((activity) => activity.name) ?? []}
        />
      </Drawer>

      <DataFetchWrapper query={prodSiteFieldDefsQuery}>
        {({ data }) => (
          <ProductionSiteFieldDefititionsTable
            activityNames={activities?.map((activity) => activity.name) ?? []}
            prodSiteFieldDefs={data}
            orgId={organizationId}
          />
        )}
      </DataFetchWrapper>
    </Stack>
  )
}
